<template>
  <div class="login-container">
    <div class="header">
      <h1>Pharmacy Login</h1>
    </div>
    
    <div class="login-form">
      <form @submit.prevent="handleLogin">
        <div class="form-group">
          <label for="contact_no1">Mobile Number</label>
          <input 
            type="text" 
            id="contact_no1"
            v-model="loginForm.contact_no1" 
            placeholder="Enter your mobile number"
            required
          />
        </div>
        
        <div class="form-group">
          <label for="password">Password</label>
          <input 
            type="password" 
            id="password"
            v-model="loginForm.password" 
            placeholder="Enter your password"
            required
          />
        </div>
        
        <button type="submit" :disabled="isLoading" class="login-btn">
          {{ isLoading ? 'Logging in...' : 'Login' }}
        </button>
      </form>
      
      <div v-if="message" :class="messageClass">
        {{ message }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginForm',
  data() {
    return {
      loginForm: {
        contact_no1: '',
        password: ''
      },
      isLoading: false,
      message: '',
      messageClass: ''
    }
  },
  methods: {
    async handleLogin() {
      this.isLoading = true
      this.message = ''
      
      try {
        const response = await fetch('https://e01.yeapps.com/medi360/login', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            contact_no1: this.loginForm.contact_no1,
            password: this.loginForm.password
          })
        })
        
        const data = await response.json()
        
        if (data.success) {
          this.message = 'Login successful! Redirecting...'
          this.messageClass = 'success-message'
          
          // Store login status and user data
          localStorage.setItem('isLoggedIn', 'true')
          localStorage.setItem('userMobile', this.loginForm.contact_no1)
          localStorage.setItem('userId', data.customer_id.toString())
          localStorage.setItem('customerName', data.customer_name || '')
          
          // Redirect after 1 second
          setTimeout(() => {
            this.$router.push('/order-history')
          }, 1000)
        } else {
          this.message = data.error || 'Password mismatch'
          this.messageClass = 'error-message'
        }
      } catch (error) {
        console.error('Login error:', error)
        this.message = 'Network error. Please try again.'
        this.messageClass = 'error-message'
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style scoped>
.login-container {
  max-width: 400px;
  margin: 50px auto;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.header {
  text-align: center;
  margin-bottom: 30px;
}

.header h1 {
  color: #333;
  margin: 0;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
  color: #555;
}

.form-group input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  box-sizing: border-box;
}

.form-group input:focus {
  outline: none;
  border-color: #007bff;
}

.login-btn {
  width: 100%;
  padding: 12px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.login-btn:hover:not(:disabled) {
  background-color: #0056b3;
}

.login-btn:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}

.success-message {
  margin-top: 15px;
  padding: 10px;
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
  border-radius: 4px;
  text-align: center;
}

.error-message {
  margin-top: 15px;
  padding: 10px;
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
  border-radius: 4px;
  text-align: center;
}

.login-container {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  background-color: #000;
  color: #e2e2e2;
  max-width: 480px;
  margin: 0 auto;
  min-height: 100vh;
  position: relative;
}

.header {
  display: flex;
  align-items: center;
  padding: 16px;
  position: sticky;
  top: 0;
  background-color: #000;
  z-index: 10;
  border-bottom: 1px solid #333;
}

.header h1 {
  margin: 0;
  color: #3aa757;
  font-size: 18px;
  flex: 1;
  text-align: center;
}

.login-form {
  padding: 24px 16px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  color: #e2e2e2;
  font-weight: 500;
  font-size: 14px;
}

.form-group input {
  width: 100%;
  padding: 14px;
  border: 1px solid #444;
  border-radius: 7px;
  background-color: #1a1a1a;
  color: #e2e2e2;
  font-size: 14px;
  box-sizing: border-box;
  transition: border-color 0.3s;
}

.form-group input:focus {
  outline: none;
  border-color: #3aa757;
}

.form-group input::placeholder {
  color: #999;
}

.login-btn {
  width: 100%;
  background-color: #3aa757;
  color: #e2e2e2;
  border: none;
  border-radius: 7px;
  padding: 16px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s;
  margin-top: 10px;
}

.login-btn:hover:not(:disabled) {
  background-color: #308de4;
}

.login-btn:disabled {
  background-color: #333;
  cursor: not-allowed;
  opacity: 0.7;
}

.success-message {
  color: #3aa757;
  text-align: center;
  margin-top: 16px;
  padding: 12px;
  background-color: #1a1a1a;
  border: 1px solid #3aa757;
  border-radius: 7px;
  font-size: 14px;
}

.error-message {
  color: #e74c3c;
  text-align: center;
  margin-top: 16px;
  padding: 12px;
  background-color: #1a1a1a;
  border: 1px solid #e74c3c;
  border-radius: 7px;
  font-size: 14px;
}
</style>